import angular from 'angular';
import template from './template.html';
import './style.scss';
import { CandidateDetailsSection, CandidateDetailsSectionConfig } from '../../../../candidate/details-section';

export class RecruiterTalentForEmployerCandidateDetailsSection extends CandidateDetailsSection {
    $onChanges() {
        super.$onChanges(...arguments);
        this.$scope.talentRecord = this.talentRecord;
    }
}

export const RecruiterTalentForEmployerCandidateDetailsSectionConfiguration = {
    ...CandidateDetailsSectionConfig,
    template,
    bindings: {
        ...CandidateDetailsSectionConfig.bindings,
        talentRecord: '<',
        printMode: '<',
    },
    controller: RecruiterTalentForEmployerCandidateDetailsSection,
    controllerAs: 'recruiterTalentForEmployerCandidateDetailsSectionCtrl'
};

angular
    .module('TALENYA-FE')
    .component('recruiterTalentForEmployerCandidateDetailsSection', RecruiterTalentForEmployerCandidateDetailsSectionConfiguration);
